import {EvkCreateServiceBase, EvkHttpService} from "@evomatik/evk-common";
import {EvkExpedienteModel} from "../models/evk-expediente.model";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class ExpedienteCreateService extends EvkCreateServiceBase<EvkExpedienteModel> {

    constructor(h: EvkHttpService) {
        super(h);
    }

    get api(): string {
        return "/seaged-expedientes-service/expediente";
    }

    evkOnBeforeSave(data: EvkExpedienteModel): Observable<EvkExpedienteModel> {
        return new Observable(
            (observer) => {
                observer.next();
            }
        );
    }

    evkOnDoneSave(response: any): void {
    }

    evkOnErrorSave(error: any): void {
    }
}
